import React, { Component } from "react";
import { get } from "../../../../../utils/request";
import "./style.css";
import "../../../../../index.css";
import "./style.css";
class MajorKeySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickName: "取消",
      name: "",
      majors: [],
    };
  }
  componentDidUpdate() {
    this.textInput.focus();
  }
  render() {
    const { placeholder, visible, majorCondition } = this.props;
    return (
      <div
        className={
          visible === true
            ? "majorKeySearch_box"
            : "majorKeySearch_box display_none"
        }
      >
        <div className="majorKeySearch_box_left fl">
          <div className="majorKeySearch_box_left_div">
            <div className="majorKeySearch_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="majorKeySearch_box_left_div_input fl">
              <input
                value={this.state.name}
                onChange={this.handleChang}
                ref={(input) => {
                  this.textInput = input;
                }}
                placeholder={placeholder}
              ></input>
            </div>
            <div
              style={{
                display: this.state.clickName === "搜索" ? "block" : "none",
              }}
              className="majorKeySearch_box_right_div_img fr"
              onClick={() => this.handleRemoveName()}
            >
              <img
                alt=""
                src={require("../../../../../images/search/search_3.png")}
              ></img>
            </div>
          </div>
        </div>
        <div className="majorKeySearch_box_right fl">
          <div
            onClick={() => this.handleCancle()}
            className="majorKeySearch_box_right_txt fl"
          >
            取消
          </div>
        </div>
        <div className="clear"></div>
        <div className="majorKeySearch_box_item">
          <div
            onClick={() => this.handleAddMajor(this.state.name)}
            className={
              this.state.name !== ""
                ? "majorKeySearch_item"
                : "majorKeySearch_item display_none"
            }
          >
            {this.state.name}
            <div
              className={
                majorCondition.includes(this.state.name)
                  ? " fr major_right_20 display_none"
                  : "fr major_right_20"
              }
            >
              <img
                alt=""
                src={require("../../../../../images/tocollege/plus.png")}
              ></img>
              <span>添加</span>
            </div>
          </div>
          {this.state.majors.map((item, index) => {
            return (
              <div key={index} className="majorKeySearch_item">
                {item}
                <div
                  onClick={() => this.handleAddMajor(item)}
                  className={
                    majorCondition.includes(item)
                      ? " fr major_right_20 display_none"
                      : "fr major_right_20"
                  }
                >
                  <img
                    alt=""
                    src={require("../../../../../images/tocollege/plus.png")}
                  ></img>
                  <span>添加</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  handleAddMajor=(item)=>{
    this.props.handleAddMajor(item);
    this.setState({
      clickName: "取消",
      name: "",
      majors: [],
    });
  }

  /**
   * 取消操作
   */
  handleCancle = () => {
    this.props.handleVisibleSearch();
    this.setState({
      clickName: "取消",
      name: "",
      majors: [],
    });
  };
  /**
   * input输入框变化的时候
   */
  handleChang = (e) => {
    this.setState({
      name: e.target.value,
    });
    if (e.target.value.length > 0) {
      get("/public/v1/intelligent/search/major/" + e.target.value).then(
        (res) => {
          this.setState({
            majors: res.data,
          });
        }
      );
    }
  };
  /**
   * 移除搜索的院校名称
   */
  handleRemoveName = () => {
    this.setState({
      clickName: "取消",
      name: "",
      majors: [],
    });
  };
}

export default MajorKeySearch;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolMajor/components/MajorKeySearch/index.js